export const BASE_URL = process.env.EUROPEANA_NEWSPAPER_API_URL || 'https://newspapers.eanadev.org/api/v2';
